import React, { useMemo } from 'react';
import { AccessorKeyColumnDef, createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import moment from '../../../../moment';
import { compareTableDates } from '../../../../utils/sort';
import Table from './Table';

export type EducationDataEntry = {
	start: string;
	end: string;
	location: {
		name: string;
		address: {
			city: string;
			houseNumber: string;
			postalCode: string;
			country: string;
			streetName: string;
			streetNameWithCity: string;
		};
	};
	product: string;
	examResult: string;
};

type Props = {
	data: EducationDataEntry[];
};
const columnHelper = createColumnHelper<EducationDataEntry>();
const EducationOverview = ({ data }: Props) => {
	const { t } = useTranslation();
	const columns = useMemo(
		() =>
			[
				columnHelper.accessor('start', {
					header: t('educations.date'),
					cell: (cellInfo) =>
						`${moment(cellInfo.row.original.start).format('DD-MM-YYYY HH:mm')} - ${moment(cellInfo.row.original.end).format('HH:mm')}`,
					sortingFn: (rowA, rowB) => compareTableDates('start', rowA, rowB),
				}),
				columnHelper.accessor('location.address.city', {
					header: t('educations.location'),
				}),
				columnHelper.accessor('product', {
					header: t('educations.product'),
				}),
				columnHelper.accessor('examResult', {
					header: t('educations.result'),
				}),
			] as Array<AccessorKeyColumnDef<EducationDataEntry, unknown>>,
		[],
	);
	return <Table data={data} columns={columns} />;
};

export default EducationOverview;
